const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function parts(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  if (!m) return null;
  return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]), idx: Math.round(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) / 86400000) };
}

/**
 * Mobile Recent Activity timestamp. One rule for every row, always showing the
 * real calendar date ("Oct 6", plus the year when it is not the current year):
 *   today       → { primary: "Today",       secondary: "3:42 PM" }   (time of day when known)
 *   1–6 days    → { primary: "2 days ago",  secondary: "Oct 6" }
 *   older/future→ { primary: "Sep 27",      secondary: "" }
 * Pure; never invents a date (returns empty strings for an unparseable one).
 */
export function formatActivityWhen(dateIso, todayIso, timeLabel = "") {
  const a = parts(dateIso);
  const t = parts(todayIso);
  if (!a) return { primary: "", secondary: "" };
  const date = `${MONTHS[a.mo - 1]} ${a.d}${t && a.y !== t.y ? `, ${a.y}` : ""}`;
  if (!t) return { primary: date, secondary: "" };
  const diff = t.idx - a.idx;
  const time = timeLabel && timeLabel !== "—" ? timeLabel : "";
  if (diff === 0) return { primary: "Today", secondary: time || date };
  if (diff === 1) return { primary: "Yesterday", secondary: date };
  if (diff > 1 && diff < 7) return { primary: `${diff} days ago`, secondary: date };
  return { primary: date, secondary: "" };
}
